import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import { makeEntityScaffold } from '@classpass/saga-tools';
import { deepExtract } from 'helpers/deep';

var flattenMsa = function flattenMsa(msa) {
  return {
    id: msa.id,
    name: msa.name,
    alias: msa.alias,
    city: msa.city,
    display_name: msa.display_name,
    default_location: msa.default_location,
    currency_code: msa.currency_code,
    currency_format: msa.currency_format,
    country_code: deepExtract('country.code', msa),
    country_id: deepExtract('country.id', msa),
    price: msa.price,
    package_purchase: msa.package_purchase,
    timezone: msa.timezone,
    version: msa.version
  };
};

export var msas = makeEntityScaffold('SAGA.API.MSAS', function (client, options) {
  return client.msas.getList(options).then(function (data) {
    return data.msas.map(flattenMsa);
  });
});
export var msaById = makeEntityScaffold('SAGA.API.MSA_BY_ID', function (client, id) {
  return client.msas.getById(id).then(flattenMsa);
}, {
  defaultKey: 1
});
export var msaCreditStatById = makeEntityScaffold('SAGA.API.MSA_CREDIT_STAT_BY_ID', function (client, msaId) {
  return client.msas.getCreditStats(msaId);
}, {
  defaultKey: 1
});
export var holdPlanByMsa = makeEntityScaffold('SAGA.API.HOLD_PLAN', function (client, msaId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.msas.getHoldPlan(msaId, options);
}, {
  defaultKey: 1
});
export var zipCodeToLatLng = makeEntityScaffold('SAGA.API.ZIP_CODE_TO_LATLNG', function (client, countryCode, zip) {
  return client.locations.getByPostalCode(zip, {
    country_code: countryCode
  });
}, {
  defaultKey: [1, 2]
});